<template>
  <div class="PaymentOptionsPicker">
    <v-radio
      v-for="payment in paymentOptions"
      :key="payment.id"
      v-model="valueLocal"
      :value="payment.id"
      :disabled="payment.disabled"
      :class="{ isPicked: valueLocal === payment.id, disabled: payment.disabled}"
      class="flex items-center"
    >
      <div class="row w-full items-center">
        <div class="column md:w-3/4">
          <div class="font-bold mb-2">{{ payment.name }}</div>
          <div>{{ payment.description }}</div>
        </div>
        <div class="column text-center ml-auto mt-2">
          <img
            :src="require(`@/assets/images/payments/${payment.id}_logo.png`)"
            :alt="payment.name"
            class="w-24"
          >
        </div>
      </div>
    </v-radio>
  </div>
</template>

<script>
import { generateComputedWithEmit } from '@/utils/componentUtils'

/**
 * @module PaymentOptionsPicker
 */
export default {
  name: 'PaymentOptionsPicker',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      paymentOptions: [
        {
          id: 'epay',
          name: 'ePay.bg',
          description: 'Плащане през системата на ePay, посредством EasyPay или през банкомат.'
        },
        {
          id: 'bonus',
          name: 'МПС Експерт Бонус Кредити',
          disabled: false,
          description: 'Плащане с МПС Експерт Бонус Кредита. 10 МПС Експерт Бонус Кредити са равни на 1 лв.'
        }
      ]
    }
  },
  computed: {
    valueLocal: generateComputedWithEmit()
  }
}
</script>

<style lang='scss'>
@import '~utils';

.PaymentOptionsPicker {
  .disabled {
  }
}
</style>
